import Backbone from 'backbone'
import Marionette from 'backbone.marionette'
import 'backbone.validation'
import './backbone.validateAll'
import './backbone-model-reset'
import './backbone-model-synced'

export default Backbone
